import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ErrorDialogData } from './error-dialog-data.model';

@Component({
	selector: 'app-error-dialog',
	styleUrls: ['./error-dialog.component.scss'],
	templateUrl: './error-dialog.component.html',
})
export class ErrorDialogComponent {
	canRetry: boolean;
	messages: string[];
	title: string;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: ErrorDialogData,
		private readonly dialogRef: MatDialogRef<ErrorDialogComponent>,
	) {
		this.title = data.title;
		this.canRetry = data.canRetry === false ? false : true;

		if (typeof data.messages === 'string') {
			const message =
				data.status === 0
					? 'Algo deu errado! Não conseguimos processar sua solicitação no momento. Por favor, tente novamente mais tarde.'
					: data.messages;
			this.messages = [message];
		} else {
			this.messages = data.messages;
		}
	}

	closeModal(retry?: boolean): void {
		this.dialogRef.close(retry);
	}

	getButtonTitle(): string {
		return this.canRetry ? 'Tentar novamente' : 'Voltar';
	}

	trackByFn(index: number): number {
		return index;
	}
}
